import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {
  ConfirmationDialogComponent
} from "@biletix/shared/components/popups/confirmation-dialog/confirmation-dialog.component";

@Component({
  selector: 'btx-yes-no-modal',
  templateUrl: './yes-no-modal.component.html',
  styleUrls: ['./yes-no-modal.component.scss'],
  standalone: false
})
export class YesNoModalComponent implements OnInit {


  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title:string, text:string}) { }

  ngOnInit(): void {
  }

}
